
import { Component, Prop, Vue } from 'vue-property-decorator';
import List from '../components/ListMobile.vue';

@Component({
  components: { List },
})
export default class MobileMainSection extends Vue {
  @Prop({ default: false }) public hideList!: boolean;
}
